/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @module
 * @description
 * Adapter allowing AngularJS v1 and Angular v2 to run side by side in the same application.
 */
export {UpgradeAdapter, UpgradeAdapterRef} from './src/upgrade_adapter';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
